import { Input } from '@lightspeed/unified-components-helios-theme/react'
import { useDropdownListContext } from '@lightspeed/unified-react-components'
import { useT } from '@transifex/react'
import React from 'react'

export const OutletSearchInput: React.FC<{
  searchInputRef: React.RefObject<HTMLInputElement>
  searchTerm: string
  onSearchTermChange: (searchTerm: string) => void
}> = ({ searchInputRef, searchTerm, onSearchTermChange }) => {
  const t = useT()
  const dropdownList = useDropdownListContext()
  const contentProps = dropdownList.getContent().props

  return (
    <div className="w-full">
      <div
        className="w-full px-4"
        onFocus={contentProps.onFocus}
        onBlur={contentProps.onBlur}
        onKeyDown={contentProps.onKeyDown}
      >
        <Input
          ref={searchInputRef}
          type="search"
          value={searchTerm}
          labelSlot={t('Search outlets', {
            _context: 'Search input label for outlet picker.',
          })}
          placeholder={t('Enter outlet name', {
            _context: 'Search input placeholder',
          })}
          onChange={onSearchTermChange}
          size="small"
          customClasses={{
            container: 'w-full py-4',
            label: 'sr-only',
            controlContainer: 'w-full',
            inputBlock: 'min-w-0 flex-1',
            mainControl: 'w-full',
          }}
        />
      </div>
    </div>
  )
}
